/**
 * @author lifei
 * 模块说明：用户中心-数据权限管理
 */
import { Service } from '@/tools'
export class PermissionConditionService<T extends TUser.PermissionCondition> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TUser.PermissionCondition}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  addCondition = <K extends T['ApiAddCondition']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAddCondition', data)

  customDate = <K extends T['ApiCustomDate']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiCustomDate', data)

  deleteCondition = <K extends T['ApiDeleteCondition']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDeleteCondition', data, '删除成功')

  pageList = <K extends T['ApiPageList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPageList', data)

  updateCondition = <K extends T['ApiUpdateCondition']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateCondition', data)

  detail = <K extends T['ApiDetail']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDetail', data)
}
